import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {Chip,Grid} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export const DraggableChips = ({items, setItems, formatField}) => {

  const onDragEnd = (result) => {
      if (!result.destination) {
          return;
      }

      const newItems = Array.from(items);
      const [removed] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, removed);

      setItems(newItems);
  };
  const handleDelete = (itemToDelete) => {
      setItems((items) => items.filter((item) => item !== itemToDelete));
  };

  return (
      <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                  <Grid container spacing={1} {...provided.droppableProps} ref={provided.innerRef}>
                      {items.map((item, index) => (
                          <Draggable key={item} draggableId={item} index={index}>
                              {(provided) => (
                                  <Grid item ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                      <Chip
                                          label={item.split('-').map((item)=>formatField(item)).join('-')}
                                          onDelete={() => handleDelete(item)}
                                          deleteIcon={<CloseIcon />}
                                          variant="outlined"
                                      />
                                  </Grid>
                              )}
                          </Draggable>
                      ))}
                      {provided.placeholder}
                  </Grid>
              )}
          </Droppable>
      </DragDropContext>
  );
}